import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../static/icons/review_info.svg'


const _hoisted_1 = { class: "review-list" }
const _hoisted_2 = { class: "review-list__header" }
const _hoisted_3 = { class: "review-list__header-container" }
const _hoisted_4 = { class: "review-list__header-title" }
const _hoisted_5 = { class: "review-list__header-rating" }
const _hoisted_6 = { class: "review-list__header-rating-current" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "review-list__header-rating-max" }, "5", -1)
const _hoisted_8 = { class: "review-list__header-info-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "review-list__header-info-icon",
  src: _imports_0
}, null, -1)
const _hoisted_10 = { class: "review-list__header-info-tooltip" }
const _hoisted_11 = { class: "review-list__header-number-of-reviews" }
const _hoisted_12 = { class: "review-list__container" }

import { getReviewsContext } from '@/composables/useReviews';
import useWebsiteText from '@/composables/useWebsiteTexts';

import Review from './Review.vue';
import ReviewStar from './ReviewStar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewList',
  setup(__props) {

const {
  reviews,
  reviewsRatingAverage,
  canFetchMoreReviews,
  fetchMoreReviews,
  totalReviews,
} = getReviewsContext();
const { websiteText } = useWebsiteText();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('review_reviews').value), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ReviewStar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(reviewsRatingAverage)) + "/ ", 1),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(websiteText)('review_infotext').value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(totalReviews)) + " " + _toDisplayString(_unref(websiteText)('review_reviews').value), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reviews), (review) => {
        return (_openBlock(), _createBlock(Review, {
          class: "review-list__container-review",
          key: review.id,
          review: review
        }, null, 8, ["review"]))
      }), 128))
    ]),
    (_unref(canFetchMoreReviews))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "review-list__fetch-more clean-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(fetchMoreReviews) && _unref(fetchMoreReviews)(...args)))
        }, _toDisplayString(_unref(websiteText)('review_showmore').value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})